import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { EServiceTemplateDataProcessingInCountriesSpecialTreatment } from "@devowl-wp/api-real-cookie-banner";
import { useMemo } from "react";
import { Tooltip } from "antd";
import { useTerritorialLegalBasisArticles } from ".";
import { reactNl2Br } from "@devowl-wp/react-utils";
function useServiceDataProcessingCountriesSpecialTreatments(param) {
    let { __, _i, predefinedDataProcessingInSafeCountriesLists, iso3166OneAlpha2, territorialLegalBasis } = param;
    const calculateTerritorialLegalBasisArticles = useTerritorialLegalBasisArticles({
        predefinedDataProcessingInSafeCountriesLists,
        iso3166OneAlpha2
    });
    const { safeCountriesList } = calculateTerritorialLegalBasisArticles(territorialLegalBasis);
    return useMemo(()=>{
        return [
            {
                label: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        __("Trans-Atlantic Data Privacy Framework self-certified provider for secure data processing in the USA"),
                        /*#__PURE__*/ _jsx("p", {
                            className: "description",
                            children: _i(__('The adequacy decision for secure data processing only applies if the provider is self certified and included in the "Data Privacy Framework List". To find out which companies are certified, {{a}}visit the website of the US government{{/a}}.'), {
                                a: /*#__PURE__*/ _jsx("a", {
                                    href: __("https://www.dataprivacyframework.gov/list"),
                                    rel: "noreferrer",
                                    target: "_blank"
                                })
                            })
                        })
                    ]
                }),
                value: EServiceTemplateDataProcessingInCountriesSpecialTreatment.ProviderIsSelfCertifiedTransAtlanticDataPrivacyFramework
            },
            {
                label: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        __("Standard contractual clauses concluded with the provider"),
                        /*#__PURE__*/ _jsx("p", {
                            className: "description",
                            children: _i(__("Did you sign a contract with the provider, e.g. when registering online? If so, the contract may contain {{a}}standard contractual clauses{{/a}} of the EU, which promise secure data processing in unsafe third countries."), {
                                a: /*#__PURE__*/ _jsx("a", {
                                    href: __("https://commission.europa.eu/law/law-topic/data-protection/international-dimension-data-protection/standard-contractual-clauses-scc_en"),
                                    rel: "noreferrer",
                                    target: "_blank"
                                })
                            })
                        })
                    ]
                }),
                value: EServiceTemplateDataProcessingInCountriesSpecialTreatment.StandardContractualClauses
            },
            {
                label: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        __("Standard contractual clauses concluded by the provider with sub-processors processing data in unsafe third countries, contractually assured"),
                        /*#__PURE__*/ _jsx("p", {
                            className: "description",
                            children: _i(__("Did you sign a contract with the provider {{ud}}{{t}}from a safe country{{/t}}{{/ud}}, e.g. when registering online? If so, the contract may contain information (e.g. in a data processing agreement) if the service provider has concluded {{a}}standard contractual clauses{{/a}} of the EU {{u}}with his own processors{{/u}}, which promise secure data processing in unsafe third countries."), {
                                t: /*#__PURE__*/ _jsx(Tooltip, {
                                    title: /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            __("Safe countries are those in which the given legal regulations apply or for which adequacy decisions exist. In your case, these are:"),
                                            /*#__PURE__*/ _jsx("br", {}),
                                            /*#__PURE__*/ _jsx("br", {}),
                                            reactNl2Br(safeCountriesList.SAFE)
                                        ]
                                    }),
                                    overlayStyle: {
                                        maxWidth: 500
                                    }
                                }),
                                a: /*#__PURE__*/ _jsx("a", {
                                    href: __("https://commission.europa.eu/law/law-topic/data-protection/international-dimension-data-protection/standard-contractual-clauses-scc_en"),
                                    rel: "noreferrer",
                                    target: "_blank"
                                }),
                                u: /*#__PURE__*/ _jsx("u", {}),
                                ud: /*#__PURE__*/ _jsx("u", {
                                    style: {
                                        textDecorationStyle: "dashed"
                                    }
                                })
                            })
                        })
                    ]
                }),
                value: EServiceTemplateDataProcessingInCountriesSpecialTreatment.ContractualAssurancesWithSubProcessors
            }
        ];
    }, []);
}
export { useServiceDataProcessingCountriesSpecialTreatments };
